// store for the library vue-stash
import clone from 'ramda/src/clone'
import keys from 'ramda/src/keys'
import forEach from 'ramda/src/forEach'
import difference from 'ramda/src/difference'
import unset from 'lodash/unset'

const initialState = {
  _common: {
    organization: null
  },
  administration: {
    channelDetail: {
      showDeleteModal: false,
      channel: {},
      channelEdit: {
        editableData: {} // TODO editableData is not necessary, use just channelEdit
      },
      settings: {},
      settingsEdit: {},
      facebook: {
        loginStatus: {} // null object pattern
      }
    },
    integrationDetail: {
      showDeleteModal: false,
      integration: {},
      form: {},
      integrationEdit: {
        editableData: {}
      }
    },
    userEdit: {
      user: {}
    }
  }
}

const store = clone(initialState)

export function restore() {
  const initialStateKeys = keys(initialState)

  const keysToRemove = difference(keys(store), initialStateKeys)

  unset(store, keysToRemove)

  forEach((key) => {
    store[key] = clone(initialState[key])
  }, initialStateKeys)
}

export default store
